export default __webpack_public_path__ + "static/1714-d6b17112907c873feb00b2cb529e7301.gif";